/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Transition_Country_MaskedInputs */

const bn_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেশ মুখোশ`)
};

const de_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LAND MASKIERT`)
};

const el_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΧΩΡΑ ΜΑΣΚΑΣΜΕΝΗ`)
};

const en_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COUNTRY MASKED`)
};

const es_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAÍS ENMASCARADO`)
};

const fr_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAYS MASQUÉ`)
};

const hi_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश नकाबपोश`)
};

const hu_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ORSZÁG MASZRKOS`)
};

const id_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEGARA BERMASKER`)
};

const it_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAESE MASCHERATO`)
};

const ja_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスクされた国`)
};

const ko_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가 마스크`)
};

const nl_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LAND GEMASKEERD`)
};

const pl_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KRAJ ZMASKOWANY`)
};

const pt_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAÍS MASCARADO`)
};

const ru_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СТРАНА В МАСКЕ`)
};

const sv_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LANDSMASKERAD`)
};

const tr_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÜLKE MASKELİ`)
};

const uk_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`КРАЇНА В МАСКАХ`)
};

const vi_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QUỐC GIA MẶT NẠ`)
};

const zh_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乡村面具`)
};

const zh_hant_cipher_transition_country_masked = /** @type {(inputs: Cipher_Transition_Country_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鄉村面具`)
};

/**
* | output |
* | --- |
* | "COUNTRY MASKED" |
*
* @param {Cipher_Transition_Country_MaskedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_transition_country_masked = /** @type {((inputs?: Cipher_Transition_Country_MaskedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Transition_Country_MaskedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_transition_country_masked(inputs)
	if (locale === "de") return de_cipher_transition_country_masked(inputs)
	if (locale === "el") return el_cipher_transition_country_masked(inputs)
	if (locale === "en") return en_cipher_transition_country_masked(inputs)
	if (locale === "es") return es_cipher_transition_country_masked(inputs)
	if (locale === "fr") return fr_cipher_transition_country_masked(inputs)
	if (locale === "hi") return hi_cipher_transition_country_masked(inputs)
	if (locale === "hu") return hu_cipher_transition_country_masked(inputs)
	if (locale === "id") return id_cipher_transition_country_masked(inputs)
	if (locale === "it") return it_cipher_transition_country_masked(inputs)
	if (locale === "ja") return ja_cipher_transition_country_masked(inputs)
	if (locale === "ko") return ko_cipher_transition_country_masked(inputs)
	if (locale === "nl") return nl_cipher_transition_country_masked(inputs)
	if (locale === "pl") return pl_cipher_transition_country_masked(inputs)
	if (locale === "pt") return pt_cipher_transition_country_masked(inputs)
	if (locale === "ru") return ru_cipher_transition_country_masked(inputs)
	if (locale === "sv") return sv_cipher_transition_country_masked(inputs)
	if (locale === "tr") return tr_cipher_transition_country_masked(inputs)
	if (locale === "uk") return uk_cipher_transition_country_masked(inputs)
	if (locale === "vi") return vi_cipher_transition_country_masked(inputs)
	if (locale === "zh") return zh_cipher_transition_country_masked(inputs)
	return zh_hant_cipher_transition_country_masked(inputs)
});